<template>
  <span class="empty-cart-button">
    <submit-button
      class="btn btn btn-danger"
      default-label="Empty Cart"
      type="reset"
      :loading="submitting"
      @click.stop.prevent="openConfirmDialog"
    />
    <confirm-dialog ref="confirmDialog" @confirm="submit">
      <p>This will remove all items from your cart. Are you sure?</p>
    </confirm-dialog>
  </span>
</template>

<script>
  import axios from 'axios'
  import ConfirmDialog from '../confirm-dialog'
  import SubmitButton from '../submit-button'

  export default {
    components: {
      ConfirmDialog,
      SubmitButton
    },
    props: {
      url: {
        type: String, required: true
      }
    },
    data() {
      return {
        submitting: false
      }
    },
    methods: {
      openConfirmDialog() {
        this.$refs.confirmDialog.open()
      },
      submit() {
        this.submitting = true
        axios.delete(this.url).then(() => {
          window.location.reload()
        }).catch((error) => {
          this.submitting = false
          // eslint-disable-next-line no-alert
          alert(error.response ? error.response.statusText : error.message)
        })
      }
    }
  }
</script>
